import { Client } from "@/Common/Api/Client";
import { IndividualLight } from "@/Common/Api/Individuals/Dto/IndividualLight";
import { Server } from "@/Common/Operations/operations.server";
import { ValidateIndividualDuplicateResponse } from "./Dto/ValidateIndividualDuplicateResponse";
import { IndividualApiMappers } from "./Mappers/IndividualApiMappers";

class IndividualApiClient {
    public static async getDuplicatesAsync(healthcardNumber: string, healthCardRegionLookupId: string): Promise<IndividualLight[]> {
        const response = await Client.postAsync<ValidateIndividualDuplicateResponse>(
            Server.Myle_ValidateIndividualDuplicate,
            {
                HealthCardNumber: healthcardNumber,
                HealthCardRegionLookupId: healthCardRegionLookupId
            }
        );

        return IndividualApiMappers.FromFindDuplicateResponseToIndividualLight(response.data);
    }
}

export { IndividualApiClient };
